module.exports = __webpack_public_path__ + "media/images/category/feature/coj_f/coj_f-6-2e4d4344d0bb21970fc99ae56eb46fbf.jpg";